import { c as _c } from "react/compiler-runtime";
// «Мои покупки › Заказ №…» — позиции одного заказа (кадр с меню «…»:
// Поддержка / Вернуть товар или Открыть спор).

import { Skeleton } from "@osmix/ui/skeleton";
import { useParams } from "react-router";
import { ProfilePanel } from "@/components/profile/profile-shell";
import { usePurchaseActions, usePurchases } from "@/components/profile/purchase-data";
import { PurchaseRow } from "@/components/profile/purchase-row";
import { CabinetEmpty } from "@/components/profile/return-parts";

// Номер заказа для крошки: короткий номер шлюза (123456, правка №13); без
// него — хвост id вида ord_….
export const orderNumberOf = (orderId: string, number?: number | null) => number ? String(number) : orderId.replace(/^ord_/, "").slice(-8).toUpperCase();
export function ProfilePurchaseOrderPage() {
  const $ = _c(18);
  const {
    orderId: t0
  } = useParams();
  const orderId = t0 === undefined ? "" : t0;
  const data = usePurchases();
  const actions = usePurchaseActions();
  let T0;
  let t1;
  let t2;
  if ($[0] !== actions || $[1] !== data.data?.items || $[2] !== data.data?.products || $[3] !== data.isPending || $[4] !== orderId) {
    let t3;
    if ($[8] !== orderId) {
      t3 = i => i.orderId === orderId;
      $[8] = orderId;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    const items = (data.data?.items ?? []).filter(t3);
    T0 = ProfilePanel;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        label: "\u041C\u043E\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0438",
        to: "/profile/purchases"
      };
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    const t5 = `Заказ №${orderNumberOf(orderId, items[0]?.orderNumber)}`;
    if ($[11] !== t5) {
      t1 = [t4, {
        label: t5
      }];
      $[11] = t5;
      $[12] = t1;
    } else {
      t1 = $[12];
    }
    t2 = data.isPending ? <div className="flex flex-col gap-2.5">{[0, 1].map(_temp)}</div> : items.length === 0 ? <CabinetEmpty title={"\u0417\u0430\u043A\u0430\u0437 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D"} hint={"\u0412\u043E\u0437\u043C\u043E\u0436\u043D\u043E, \u043E\u043D \u0435\u0449\u0451 \u043D\u0435 \u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D."} /> : <div className="flex flex-col gap-2.5">{items.map(item => <PurchaseRow key={item.orderLineId} item={item} product={data.data?.products.get(item.productId)} busy={actions.busyId === item.orderLineId + item.orderId} onToCart={() => void actions.toCart(item, data.data?.products.get(item.productId))} onReturn={() => void actions.startReturn(item)} onDispute={() => actions.openDispute(item)} onSupport={actions.openSupport} />)}</div>;
    $[0] = actions;
    $[1] = data.data?.items;
    $[2] = data.data?.products;
    $[3] = data.isPending;
    $[4] = orderId;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
  }
  let t3;
  if ($[13] !== T0 || $[14] !== actions.modals || $[15] !== t1 || $[16] !== t2) {
    t3 = <T0 crumbs={t1}>{t2}{actions.modals}</T0>;
    $[13] = T0;
    $[14] = actions.modals;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}
function _temp(i_0) {
  return <Skeleton key={i_0} className="h-[149px] rounded-[20px]" />;
}